import React from 'react';
import { PlayerButton } from './PlayerButton';

interface FullscreenButtonProps {
  isFullscreen: boolean;
  onClick: () => void;
}

export const FullscreenButton = React.memo(function FullscreenButton({ isFullscreen, onClick }: FullscreenButtonProps) {
  return (
    <PlayerButton
      className={`kollab-player-fullscreen-btn ${isFullscreen ? 'kollab-player-fullscreen-btn--active' : ''}`}
      tooltip={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      onClick={onClick}
    />
  );
});
